<template>
    <div>
        <div class="header-return">

          <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>

        </div>
            <el-form :model="form" label-width="150px">
                <el-form-item label="linkId" :hidden="true">
                    <el-input v-model=form.id></el-input>
                </el-form-item>
              <el-form-item label="页面名称" >
                <el-select v-model="form.pageLinkId" placeholder="页面名称" :disabled="true" >
                  <el-option v-for="item in pageLinkOptionList"
                             :key="item.linkId"
                             :label="item.pageTitle"
                             :value="item.linkId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="页面路径" >
                <el-input v-model=form.pageUrl :disabled="true" ></el-input>
              </el-form-item>

              <el-form-item label="事件标识">
                  <el-input v-model=form.event clearable placeholder="事件标识"></el-input>
                  <span>用于标识在哪个事件添加订阅消息，可不填写，默认取default</span>
              </el-form-item>
              <el-form-item label="活动">
                <el-select v-model="form.bindCode" clearable filterable placeholder="活动">
                  <el-option v-for="item in activeList"
                             :key="item.bindCode"
                             :label="item.activeName"
                             :value="item.bindCode">
                  </el-option>
                </el-select>
                如不选择，按照页面订阅消息，如果选择了活动，则按照具体活动订阅消息
              </el-form-item>
              <el-form-item label="订单来源">
                <el-select v-model="form.orderSource" filterable  placeholder="订单来源">
                  <el-option v-for="item in orderSourceData"
                             :key="item.dictionaryKey"
                             :label="item.dictionaryName"
                             :value="item.dictionaryKey">
                  </el-option>
                </el-select>可选
              </el-form-item>
              <el-form-item label="订阅模板">
                <el-select v-model="form.templateId" clearable filterable placeholder="订阅模板">
                  <el-option v-for="item in templateList"
                             :key="item.messageId"
                             :label="item.messageName"
                             :value="item.messageId">
                  </el-option>
                </el-select>
                <span style="color: red">*</span>
              </el-form-item>
                <el-form-item label="备注" >
                    <el-input v-model=form.remark clearable placeholder=""></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="save()">保存</el-button>
                </el-form-item>
            </el-form>

    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
      savePageLink,
      getValidDictionaryList,
      templateSubcriptGetSingle,
      getPageLinkTypeList,
      getPlatformList2, getPageLinkOption,getActiveForOption,getSubscribeTemplateMessageList,templateSubcriptSave
    } from '../../api/api'
    export default{
        data(){
            return {

              loading: false,
              id:this.$route.params.id,

              typeList:[],
              platformData:[],
              activeList:[],
              templateList:[],
              platformDisabled:this.$route.params.id==0?false:true,
              pageLinkOptionList:[],
              orderSourceData:[],
              form: {
                  id: null,
                  templateId: null,
                  sence: null,
                  creatTime: '',
                  remark: '',
                  platformId:this.$route.params.platformId,
                  pageLinkId:parseInt(this.$route.params.pageLinkId),
                  pageUrl:'',
                  event:'default',
                  bindCode:null,
                  orderSource:null
              },
              formInline:{
                platformId:this.$route.params.platformId,
                pageLInkId:parseInt(this.$route.params.pageLinkId),
              }
            }
        },

        //挂载时候执行
        mounted(){
            //初始化活动类型
            //this.getActiveTypeList();
            this.getSubscribeTemplateMessageList();
            this.getPageLinkOptionList();
            this.getActiveForOption();
            getValidDictionaryList({dictionaryTypeId:14}).then((res) => {
              //console.log(res.data.value.list);
              if(res.data.success){

                var orderSource= res.data.value.list;
                for(var key in orderSource){
                  //console.log("dic:"+key);
                  orderSource[key].dictionaryKey=parseInt(orderSource[key].dictionaryKey);
                }
                this.orderSourceData=orderSource;
              }
            });

            this.initDetail();

        },
        methods: {
          getActiveForOption(){
            this.loading = true;
            getActiveForOption().then((res) => {
              this.loading = false;
              this.activeList = res.data.value;
            })
          },
          getPageLinkOptionList(){
            this.loading = true;
            getPageLinkOption(this.formInline).then((res) => {
              this.loading = false;
              this.pageLinkOptionList = res.data.value;
            })
          },
          getSubscribeTemplateMessageList(){
            this.loading = true;
            getSubscribeTemplateMessageList(this.formInline).then((res) => {
              this.loading = false;
              this.templateList = res.data.value;
            })
          },
          initDetail(){
              //if(this.id>0){
                  this.loading = true;
                templateSubcriptGetSingle({id: this.id,platformId:this.formInline.platformId,pageLinkId:this.formInline.pageLInkId}).then(res=>{
                      this.loading = false;
                      console.log(res)
                      this.form = res.data.value
                  })
             // }
          },

            save(){
                console.log(this.form);
                if (this.form.templateId == ""||this.form.templateId == null) {
                    this.$message({
                        message: "请选择订阅模板",
                        type: 'error'
                    });
                    return;
                }

                this.loading = true;

              templateSubcriptSave(this.form).then((res) => {
                    //console.log(res);
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.id=res.data.value;
                        this.initDetail();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },

        }
    }

</script>
<style>
    .p {
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/views/wechat/templateScriptConfigDetail.vue